__turbopack_context__.v({
  "placeholder": "error-module-scss-module__xBKUBq__placeholder",
  "section": "error-module-scss-module__xBKUBq__section",
});
